// USA
export const locale = {
  lang: "th",
  data: {
    TRANSLATOR: {
      SELECT: "Select your language",
    },
    MENU: {
      NEW: "new",
      ACTIONS: "Actions",
      CREATE_POST: "Create New Post",
      PAGES: "Pages",
      FEATURES: "Features",
      APPS: "Apps",
      DASHBOARD: "แดชบอร์ด",
      CALENDAR_YEAR: "ปีปฎิทิน",
      SPECIAL_LEAVES: "กรณีพิเศษ",
      ENTRY_INFO: "ข้อมูลการเข้างาน",
      LEAVE_LATE_INFO: "ข้อมูลการลา, สาย",
      SALARY: "เงินเดือน",
      ALLOWANCE: "เบี้ยเลี้ยง",
      SETTING: "การตั้งค่า",
      ENTRY_EXIT_TIME: "เวลาเข้า - ออกงาน",
      COMPONENT: "Component",
      COMMISSION: "คอมมิชชั่น",
      EMPLOYEE: "พนักงาน",
      USER: "ผู้ใช้งาน",
      PERMISSION: "บทบาทการใช้งาน",
      HOLIDAY: "วันหยุด",
      LEAVE: "การลา",
      FINE: "ค่าปรับ",
      COMPANY_INFORMATION: "ข้อมูลบริษัท",
      DEPARTMENT_INFORMATION: "ข้อมูลแผนก",
      JOB_POSITION: "ตำแหน่งงาน",
      POLICY_MANAGEMENT: "กฏระเบียบในการทำงาน",
      BANK: "ธนาคาร",
      BANK_NUMBER: "เลขที่บัญชี",
      COMMISSIONS: "คอมมิชชั่น",
      OTHER: "ค่าเสียหาย/อื่นๆ",
      COLLECT_POINTS: "แต้มสะสม",
      PAYROLL_SLIPS: "รูปแบบสลิปเงินเดือน",
      AUDIT_LOG: "บันทึกการตรวจสอบ",
      REPORT_ATTENDANCE_LEAVINGS: "รายงาน",
      CHANGE_PASSWORD: "เปลี่ยนรหัสผ่าน",
    },
    FILTERS: {
      DATE: "วันที่",
      COMPANY: "บริษัท",
      DEPARTMENT: "แผนก",
      EMPLOYEE: "พนักงาน",
      LEAVE_TYPES: "ประเภทการลา",
      POSITION: "ตำแหน่ง",
      DATE_RANGE: "ช่วงวันที่",
      DISPLAY: "เลือกดู",
      MONTHS: "เดือน",
      SEARCH_BY_NAME: "ค้นหาจากชื่อ",
      STATUS: "สถานะ",
      COMMISSION: "ยอดคอมมิชชั่น",
      NAME: "ชื่อ - นามสกุล",
      COMMISSION_ROUND: "รอบของค่าคอมมิชชั่น",
      TIME_INTERVAL: "ระบุช่วงเวลา",
    },
    APP: {
      ACCOUNT_PROFILE: "ข้อมูลส่วนตัว",
      DRAFT: "แบบร่าง",
      WAITING_DOC: "เอกสารรอส่ง",
      IN_PROGRESS: "กำลังดำเนินการ",
      HISTORY: "ประวัติ",
      ATTACHMENTS: "ไฟล์แนบ",
      DOC_NO: "เลขที่",
      DATE: "วันที่",
      DOCUMENT_NO: "เลขที่เอกสาร",
      REQUEST_INFORMATION: "ข้อมูลคำร้อง",
      CONCLUSION: "พิจารณาสรุปผล",
      REVISE_FILE: "แก้ไขเอกสาร",
      TIMELINE: "Timeline",
      ISSUE_NO: "เลขที่หนังสือ",
      SUBJECT: "เรื่อง",
      DEAR: "เรียน",
      NAME_TITLE: "คำนำหน้าชื่อ",
      NAME: "ชื่อ",
      FIRST_NAME: "ชื่อ",
      LAST_NAME: "นามสกุล",
      TYPE: "ประเภท",
      CURRENT_POSITION: "ตำแหน่งปัจจุบัน",
      ACADEMIC_POSITION: "ตำแหน่ง",
      SKILL: "ความเชี่ยวชาญ",
      MAJOR: "สังกัดสาขาวิชา",
      MAJOR_NAME: "สาขาวิชา",
      DEPARTMENT_MAJOR: "ภาควิชา",
      DEPARTMENT: "ฝ่าย",
      FACULTY: "คณะ",
      PHONE: "เบอร์โทรศัพท์",
      DOCUMENT_CREATER: "ผู้สร้างเอกสาร",
      REQUESTER: "ผู้ยื่นขอประเมิน",
      REQUESTER_INLINE: "ผู้ยื่นขอประเมิน:",
      DATE_FORMAT: "วัน/เดือน/ปี",
      REQUEST_EVALUATION: "ขอรับการประเมินผลการสอน",
      FIRST_SEMESTER: "ภาคต้น",
      SECOND_SEMESTER: "ภาคปลาย",
      SEMESTER_YEAR: "ปีการศึกษา",
      YEAR: "ปี",
      MONTH: "เดือน",
      DAY: "วัน",
      SUBJECT_CODE: "รหัสวิชา",
      SUBJECT_NAME: "รายวิชา",
      SUBJECT_NAME_PLACEHOLDER: "ชื่อวิชาภาษาไทย (ชื่อวิชาภาษาอังกฤษ)",
      DEGREEE: "ระดับการศึกษา",
      REQUEST_POSITION: "ตำแหน่งที่ขอ",
      TOPIC: "หัวข้อ",
      TAUGHT_TOPIC: "หัวข้อที่สอน",
      PLEASE_SPECIFY: "โปรดระบุหัวข้อ",
      EVALUATION_LECTURE_SUBJECT: "หัวข้อประเมินบรรยาย",
      EVALUATION_PRACTICAL_SUBJECT: "หัวข้อประเมินปฏิบัติ",
      FILE_SECTION_TXT_1:
        "หัวข้อที่เคยประเมินในระดับ ผู้ช่วยศาสตราจารย์ (ยื่นขอ รศ. ใช้ระดับ ผศ.)",
      FILE_SECTION_TXT_2: "เอกสารประกอบการประเมินการสอน",
      FILE_SECTION_TXT_VALUE: "เอกสารประกอบการประเมินการสอน {{value}} เอกสาร",
      FILE_NAME: "ชื่อไฟล์",
      FILE_PLACEHOLDER: "เลือกหรือลากและวางไฟล์ลงที่นี่",
      FILE_PLACEHOLDER_ADD_ON: "รองรับไฟล์นามสกุล PDF",
      FILE_PLACEHOLDER_2: "ลากและวางไฟล์ลงที่นี่หรือ",
      COPY_OF_APPLICATION_FROM_HEAD:
        "ยื่น แบบเสนอขอประเมินผลการสอนเพื่อประกอบการยื่นขอกำหนดตำแหน่งทางวิชาการ",
      COPY_OF_APPLICATION_FROM_HEAD_VIEW:
        "แบบเสนอขอประเมินผลการสอนเพื่อประกอบการยื่นขอกำหนดตำแหน่งทางวิชาการ",
      COPY_OF_APPLICATION_FROM_HEAD_WARNING:
        "กรุณาสร้าง แบบขอประเมินฯ (PDF) เพื่อยื่นหัวหน้าสาขาฯ ลงนาม digital ก่อนยืนประเมินทุกครั้ง",
      // COPY_OF_APPLICATION_FROM_HEAD: 'สำเนาแบบยื่นคำร้องที่อนุมัติจากหัวหน้าสังกัดสาขาวิชา',
      UPLOADED_FILE: "ไฟล์ที่อัปโหลด",
      REVISION_FILE: "แก้ไขครั้งที่",
      REMARK: "หมายเหตุ",
      BY: "โดย",
      TEL: "โทร",
      PASS: "ผ่าน",
      FAIL: "ไม่ผ่าน",
      HAS_ADDITIONAL_EDIT: "มีแก้ไขเพิ่มเติม",
      NO_ADDITIONAL_EDIT: "ไม่มีแก้ไขเพิ่มเติม",
      DOC_REVISED_MSG: "กรุณาแก้ไขเอกสารประกอบการประเมินการสอน",
      CERTIFICATE: "ใบรับรอง",
      PART_3: "ส่วนที่ 3 แบบประเมินผลการสอน",
      CURRENT_INFORMATION: "ข้อมูลปัจจุบัน",
      FULL_NAME: "ชื่อ-สกุล",
      SEMESTER: "ภาคการศึกษา",
      EVALUATION_INFORMATION: "รายละเอียดการประเมินผลการสอน",
      EVALUATION_CONFERENCE_DATE: "วันที่ประชุมประเมินผลการสอน",
      APPROVE_REOPEN_DOC: "อนุญาตแก้ไขคำขอประเมิน",
      APPROVE_REOPEN_REQ: "อนุญาตแก้ไขคำขอ",
      EVALUATION_DATE: "วันที่ประชุม",
      EVALUATION_DATE_INLINE: "วันที่ประชุม:",
      TEACHING_EVALUATION_LEVEL: "ผลการประเมินการสอนอยู่ในระดับ",
      EVALUATION_CERTIFIER: "ผู้รับรองการประเมิน",
      POSITION: "ตำแหน่ง",
      APPROVAL_DATE: "วันที่อนุมัติ",
      DEPUTY_DEAN_APPROVAL: "เสนอรองคณบดีเพื่อพิจารณาอนุมัติการประเมิน",
      DEPUTY_DEAN: "รองคณบดี",
      DEAN_NAME: "ชื่อคณบดี",
      DOCUMENT_STATUS_HISTORY: "ประวัติสถานะเอกสาร",
      ASSESSMENT_REQUEST_TRACKING: "ติดตามสถานะคำขอประเมิน",
      TRACKING_PAGE_WORDING: "กรอกหมายเลขเอกสารหรือชื่อผู้ยื่นขอประเมิน",
      SEARCH_PLACEHOLDER: "ค้นหาเลขที่, เรื่อง",
      SEARCH_USER_PLACEHOLDER: "ค้นหาชื่อ, อีเมล",
      SEARCH_PLACEHOLDER_TRACKING: "ค้นหาหมายเลข",
      TRACKING_PLACEHOLDER:
        "ค้นหาสถานะคำขอประเมิน คณะแพทยศาสตร์ มหาวิทยาลัยขอนแก่น",
      TRACKING_NOT_FOUND: "ไม่พบเอกสารกรุณาตรวจสอบคำค้นหาหรือติดต่อเจ้าหน้าที่",
      EMAIL: "อีเมล",
      GENERAL_INFORMATION: "ข้อมูลทั่วไป",
      CONTACT_INFORMATION: "ข้อมูลการดิดต่อ",
      PLACE: "สถานที่",
      NEW_EVENT: "สร้างกิจกรรมใหม่",
      START_TIME: "เวลาเริ่มต้น",
      END_TIME: "เวลาสิ้นสุด",
      EVENT_TITLE: "ชื่อกิจกรรม",
      PREVIOUSLY_ASSESSED: "หัวข้อที่เคยประเมินในระดับ {{position}}",
      IS_PREVIOUSLY_ASSESSED:
        "เป็นหัวข้อเดิมที่ใช้ประเมินการสอน {{value}} ใช่หรือไม่",
      TOPIC_NAME: "ชื่อหัวข้อ",
      PLEASE_ATTACH_DOCUMENTATION: "โปรดแนบเอกสารชี้แจง",
      CLARIFICATION_DOCUMENT: "เอกสารชี้แจง",
      REQUESTER_INFORMATION: "ข้อมูลผู้ยื่นขอประเมิน",
      ASSESSMENT_COMMITTEE: "กรรมการประเมิน",
      RESERVE_ASSESSMENT_COMMITTEE: "กรรมการประเมิน(สำรอง)",
      INTERNAL: "ภายใน",
      EXTERNAL: "ภายนอก",
      CHAIRMAN: "ประธาน",
      CHAIRMAN_INLINE: "ประธาน",
      ADD: "เพิ่ม",
      ACKNOWLEDGE: "การตอบรับ",
      AVAILABLE_DATE_TIME: "วัน/เวลา ที่สะดวก",
      SELECT_AVAILABLE_MEETING_DATE_TIME:
        "กรุณาเลือก วัน/เวลา ที่สะดวกประชุมพิจารณา",
      SELECT_AVAILABLE_MEETING_DATE_TIME_DESC:
        "*กรุณาเลือกวันที่และเวลาเพื่อประชุมพิจารณาและสรุปผล",
      INVITATION_LETTER: "หนังสือเชิญประชุม",
      SEGMENT: "ส่วนงาน",
      DEAR_COMMITTEE: "เรียนกรรมการ",
      CONTENT: "เนื้อหา",
      REQUESTER_FULL_NAME: "ชื่อ-สกุล ผู้ยื่นขอประเมิน",
      INVITATION_DATE_TIME: "วัน/เวลา เชิญเข้าประชุม",
      TIME_FORMAT: "ชั่วโมง:นาที",
      TIME: "เวลา",
      LOCATION: "สถานที่",
      ROOM: "ห้อง",
      OFFICE: "สำนักงาน",
      FLOOR: "ชั้น",
      PROCESS_DATE: "วันดำเนินการ",
      APPOINT_A_COMMITTEE: "แต่งตั้งกรรมการ",
      TEACHING_EVALUATION_REPORT_FORM: "แบบฟอร์มรายงานผลประเมินการสอน",
      EXPERT: "ชำนาญ",
      SPECIAL_EXPERTISE: "ชำนาญพิเศษ",
      SPECIALIZE: "เชี่ยวชาญ",
      SUGGESTION_NOTES: "บันทึกแจ้งข้อเสนอแนะ",
      SUGGESTION_NOTES_RESULT: "บันทึกแจ้งผลการประเมิน",
      UPDATED_AT: "วันที่อัปเดต",
      OPTION: "ตัวเลือก",
      CHECK_THE_REVISED_DOCUMENT: "ตรวจสอบเอกสารแก้ไข",
      NOTE: "หมายเหตุ",
      REJECT_NOTE: "หมายเหตุการปฏิเสธ",
      DISAPPROVE_NOTE: "หมายเหตุการแก้ไข",
      MAIN_TEAM: "ชุดหลัก",
      RESERVE_TEAM: "ชุดสำรอง",
      ACCEPT: "ตอบรับ",
      ALREADY_ACCEPT: "ตอบรับแล้ว",
      REJECT: "ปฏิเสธ",
      WAITING: "รอตอบรับ",
      APPROVE: "อนุมัติ",
      COMMENT: "ความคิดเห็น",
      COMMENT_FOR_FILE: "ความคิดเห็นสำหรับไฟล์",
      COMMITTEE_MEMBER: "กรรมการ",
      DEAR_REQUESTER: "เรียน ผู้ยื่นขอประเมิน",
      DETAIL: "รายละเอียด",
      DETAIL_REVISED: "รายละเอียดการแก้ไข",
      DETAIL_REJECT: "รายละเอียดการแก้ไข",
      LAST_DETAIL_REJECT: "รายละเอียดการแก้ไขก่อนหน้า",
      DOCUMENT_NAME: "ชื่อเอกสารประกอบการสอน",
      EVALUATION_RESULT: "ผลการประเมิน",
      WAITING_FOR_THE_COMMITTEE_RESPOND: "รอกรรมการประเมินตอบรับ",
      INVITATION_TITLE: "เรียนเชิญตอบรับเป็นอนุกรรมการประเมินผลการสอน",
      INVITATION_TEXT:
        "ขอเรียนเชิญท่านตอบรับเป็นคณะกรรมการประเมินผลการสอนเพื่อขอกำหนดตำแหน่งทางวิชาการ",
      COMMITTEE_INFORMATION: "ข้อมูลกรรมการ",
      CREATE_APPOINT_LETTER:
        "สร้างหนังสือคำสั่งแต่งตั้งคณะกรรมการประเมินการสอน",
      APPOINT_LETTER: "หนังสือคำสั่งแต่งตั้งคณะกรรมการประเมินการสอน",
      ORDER_OF_THE_FACULTY_OF_MEDICINE: "คำสั่งคณะแพทย์ศาสตร์",
      APPOINT_DATE: "วันที่แต่งตั้ง",
      ORDER_DATE: "วันที่ออกคำสั่ง",
      DOC_DATE: "วันที่สร้างเอกสาร",
      DOC_DATE_INLINE: "วันที่สร้างเอกสาร:",
      EXPIRED_DATE: "วันที่สิ้นสุดการแก้ไข",
      EXPIRED_DATE_INLINE: "วันที่สิ้นสุดการแก้ไข:",
      ORDER_CONTENT: "เนื้อหาคำสั่ง",
      ABOUT_1: "ว่าด้วย",
      BY_VIRTUE_OF_THE_SECTION: "อาศัยอำนาจตามความในมาตรา",
      LIST_OF_REQUESTER_AND_COMMITTEE: "รายชื่อผู้เสนอขอและคณะอนุกรรมการ",
      ORDER_NO: "ลำดับที่",
      POSITION_APPLICANT: "ผู้ขอกำหนดตำแหน่ง",
      POSITIONING: "ขอกำหนดตำแหน่ง",
      QUALIFIED: "ผู้ทรงคุณวุฒิ",
      QUALIFIED_ADDRESS: "ที่อยู่ผู้ทรงคุณวุฒิ",
      ORDER_MEMORANDUM:
        "บันทึกข้อความ หนังสือคำสั่งแต่งตั้งคณะกรรมการประเมินการสอน",
      POSITIONING_LIST: "จำนวนผู้ยื่นประเมินการสอนกำหนดตำแหน่ง {{value}} ราย",
      MORNING: "เช้า",
      AFTERNOON: "บ่าย",
      LETTER_FILE:
        "ไฟล์หนังสือคำสั่งแต่งตั้งคณะกรรมการประเมินการสอนที่ได้รับการอนุมัติ",
      APPROVE_LETTER_FILE:
        "ไฟล์ใบรับรองการอนุมัติการขอกำหนดตำแหน่งทางวิชาการที่ได้รับการอนุมัติ",
      PLASE_SELECT_DATE: "กรุณาเลือกวันที่",
      VIEW_FILE: "ดูเอกสารประกอบ",
      COMMITTEE_INFO_NOT_FOUND:
        "ไม่พบข้อมูลการเชิญเป็นกรรมการประเมิน กรุณาติดต่อเจ้าหน้าที่เพื่อตรวจสอบข้อมูล",
      COMMITTEE_INFO_IS_REJECTED:
        "กรรมการประเมินได้ปฏิเสธเข้าร่วมประชุมการประเมินแล้ว",
      COMMITTEE_MAIN_IS_ACCEPTING:
        "กรรมการชุดหลักกำลังตรวจสอบช่วงเวลาในตอบรับการประชุม",
      WAITING_FOR_RESULT: "รอผลการประเมินจากคณะกรรมการ",
      WAITING_FOR_REVISE: "รอการแก้ไขเอกสารจากผู้ยื่นขอประเมิน",
      CHECKING_BY_CHAIRMAN: "ประธานตรวจสอบเอกสารแก้ไข",
      CHAIRMAN_ONLY: "ประเมินโดยประธานกคณะกรรมการเท่านั้น",
      WAITING_FOR_APPROVAL: "รอการอนุมัติ",
      APPROVED: "อนุมัติแล้ว",
      //
      INLINE_SEARCH: "ค้นหา:",
      YES: "ใช่",
      NO: "ไม่ใช่",
      NO_EVENTS: "ไม่มีกิจกรรม",
      NO_ITEMS: "ไม่มีรายการ",
      NO_ITEMS_FOUND: "ไม่มีรายการแสดง",
      NO_FILE_UPLOAD: "ไม่มีไฟล์ที่อัปโหลด",
      NO_REVISED_FILE: "ไม่มีไฟล์ที่แก้ไข",
      NO_COMMENTS: "ไม่มีความคิดเห็น",
      SLOT_TIMES: "ช่วงเวลา",
      PLEASE_COMMENT: "กรุณากรอกคำแนะนำ",

      //Approver
      MEETING_INVITEE: "ผู้เชิญประชุม",
      APPROVER: "ผู้รับรอง",
      HEAD_OF_DEPARTMENT: "หัวหน้าสาขา",
      HEAD_OF_DEPARTMENT_NAME: "ชื่อหัวหน้าสาขา",
      APPROVER_NAME: "ชื่อผู้รับรอง",
      APPROVER_DEPARTMENT: "หัวหน้าภาค",
      APPROVER_CHIEF: "หัวหน้าหน่วยการเจ้าหน้าที่",
      APPROVER_DEAN: "ประธานอนุกรรมการประเมินผลการสอน  คณะแพทยศาสตร์",
      // APPROVER_DEAN: 'ประธานคณะอนุกรรมการ คณะแพทยศาสตร์',
      APPROVER_SIRIKIT:
        "รองคณบดีฝ่ายศูนย์หัวใจสิริกิติ์ ภาคตะวันออกเฉียงเหนือ และบริหารทรัพยากรบุคคล",

      USER: "รายชื่อผู้ใช้",

      LOADING: "กำลังโหลด",
      PROCESSING: "กำลังประมวลผล",
      DOC_NO2: "หมายเลขเอกสาร",

      // REPORTS
      DATE_PERIOD: "วัน",
      MONTH_PERIOD: "เดือน",
      YEAR_PERIOD: "ปี",
      INLINE_DATE_RANGE: "ช่วงวันที่:",
      INLINE_DATE: "วันที่:",
      INLINE_MONTH: "เดือน:",
      INLINE_YEAR: "ปี:",
      TO: "ถึง",
      START_DATE: "วันที่เริ่มต้น",
      END_DATE: "วันที่สิ้นสุด",
      REQUEST_DATE_FILTER: "วันที่ยื่นเสนอขอ",
      APPROVE_DATE_FILTER: "วันที่อนุมัติ",
      FIELD_OF_STUDY: "สังกัดสาขาวิชา",
      REQUEST_STATUS: "สถานะการยื่นขอ",
      OWNER_NAME: "ชื่อผู้ยื่น",
      SELECT_COMMITTEE_PLACEHOLDER: "กรุณาเลือกรายชื่อกรรมการ",
      COMMITTEE_NAME: "ชื่อกรรมการ",
      INTERNAL_COMMITTEE: "กรรมการภายใน",
      EXTERNAL_COMMITTEE: "กรรมการภายนอก",
      ALL_COMMITTEE: "รวมกรรมการทั้งสิ้น",
      COMMITTEE_TYPE: "ประเภทกรรมการ",

      AMOUNT_DAY_APPROVE: "จำนวนวันที่ขอเพิ่ม",

      ITEMS: "รายการ",
    },
    AUTH: {
      GENERAL: {
        OR: "Or",
        SUBMIT_BUTTON: "Submit",
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: "Sign Up",
        FORGOT_BUTTON: "Forgot Password",
        BACK_BUTTON: "Back",
        PRIVACY: "Privacy",
        LEGAL: "Legal",
        CONTACT: "Contact",
      },
      LOGIN: {
        TITLE: "Login Account",
        BUTTON: "Sign In",
      },
      FORGOT: {
        TITLE: "Forgotten Password?",
        DESC: "Enter your email to reset your password",
        SUCCESS: "Your account has been successfully reset.",
      },
      REGISTER: {
        TITLE: "Sign Up",
        DESC: "Enter your details to create your account",
        SUCCESS: "Your account has been successfuly registered.",
      },
      INPUT: {
        EMAIL: "Email",
        FULLNAME: "Fullname",
        PASSWORD: "Password",
        CONFIRM_PASSWORD: "Confirm Password",
        USERNAME: "Username",
      },
      VALIDATION: {
        INVALID: "{{name}} is not valid",
        REQUIRED: "{{name}} is required",
        MIN_LENGTH: "{{name}} minimum length is {{min}}",
        AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
        NOT_FOUND: "The requested {{name}} is not found",
        INVALID_LOGIN: "The login detail is incorrect",
        REQUIRED_FIELD: "Required field",
        MIN_LENGTH_FIELD: "Minimum field length:",
        MAX_LENGTH_FIELD: "Maximum field length:",
        INVALID_FIELD: "Field is not valid",
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: "Selected records count: ",
        ALL: "All",
        SUSPENDED: "Suspended",
        ACTIVE: "Active",
        FILTER: "Filter",
        BY_STATUS: "by Status",
        BY_TYPE: "by Type",
        BUSINESS: "Business",
        INDIVIDUAL: "Individual",
        SEARCH: "Search",
        IN_ALL_FIELDS: "in all fields",
      },
      ECOMMERCE: "eCommerce",
      CUSTOMERS: {
        CUSTOMERS: "Customers",
        CUSTOMERS_LIST: "Customers list",
        NEW_CUSTOMER: "New Customer",
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: "Customer Delete",
          DESCRIPTION: "Are you sure to permanently delete this customer?",
          WAIT_DESCRIPTION: "Customer is deleting...",
          MESSAGE: "Customer has been deleted",
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: "Customers Delete",
          DESCRIPTION: "Are you sure to permanently delete selected customers?",
          WAIT_DESCRIPTION: "Customers are deleting...",
          MESSAGE: "Selected customers have been deleted",
        },
        UPDATE_STATUS: {
          TITLE: "Status has been updated for selected customers",
          MESSAGE: "Selected customers status have successfully been updated",
        },
        EDIT: {
          UPDATE_MESSAGE: "Customer has been updated",
          ADD_MESSAGE: "Customer has been created",
        },
      },
    },
    COMPONENT: {
      ADD: "เพิ่ม",
      NEW_REQUEST: "สร้างคำขอประเมิน",
      CREATE: "สร้าง",
      EDIT: "แก้ไข",
      DELETE: "ลบ",
      VIEW_DATA: "ดูข้อมูล",
      DOWNLOAD: "ดาวน์โหลด",
      UPLOAD: "อัปโหลด",
      BROWSE_FILE: "เลือกไฟล์",
      PRINT: "พิมพ์",
      PRINT_REQ: "PDF เอกสารข้อมูลคำร้อง",
      CREATE_REQ_DOC: "สร้างเอกสารแบบเสนอขอประเมินฯ",
      SAVE: "บันทึก",
      SAVE_DRAFT: "บันทึกแบบร่าง",
      SUBMIT_REQUEST: "ยื่นขอประเมิน",
      VIEW_DETAIL: "ดูรายละเอียด",
      SAVE_CHANGES: "บันทึกการเปลี่ยนแปลง",
      NEW_EVENT: "สร้างกิจกรรมใหม่",
      CONFIRM: "ยืนยัน",
      ACCEPT: "ตอบรับ",
      REJECT: "ปฏิเสธ",
      SUBMIT_EDIT: "ส่งแก้ไข",
      DISAPPROVE: "ไม่อนุมัติ",
      APPROVE: "อนุมัติ",
      APPROVED: "ผ่านการตรวจสอบ",
      CONFIRM_REJECT: "ยืนยืนปฏิเสธ",
      CONFIRM_DISAPPROVE: "ยืนยันส่งแก้ไข",
      SUBMIT: "ส่ง",
      VIEW_COMMENT: "ดูความคิดเห็น",
      SUBMIT_REVISION_DOCUMENT: "ส่งเอกสารแก้ไข",
      APPROPRIATE: "เหมาะสม",
      MUST_REVISE: "ต้องแก้ไข",
      SEND_EMAIL: "ส่งอีเมล",
      ISSUE_A_CERTIFICATE: "ออกใบรับรอง",
      CANCEL: "ยกเลิก",
      CLOSE: "ปิด",
      NEXT: "ถัดไป",
      IMPORT_DATA: "นำเข้าข้อมูล",
      IMPORT_PERSONNEL_DATA: "นำเข้าข้อมูลบุคลากร",
      FILE_FORMAT: "รูปแบบไฟล์",
      DOWNLOAD_SLIP: "ดาวน์โหลดสลิป",
    },
    VALIDATOR: {
      REQUIRED: "กรุณากรอกข้อมูล",
      REQUIRED_DATE: "กรุณากรอกข้อมูลตั้งแต่ 1 วันขึ้นไป",
      MUST_BE_AT_LEAST_X_CHARACTERS: "จำนวนตัวอักษรอย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_LETTER_IN_LOWER_CASE:
        "ตัวพิมพ์เล็ก [a-z] อย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_LETTER_IN_UPPER_CASE:
        "ตัวพิมพ์ใหญ่ [A-Z] อย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_NUMBER: "ตัวเลข [0-9] อย่างน้อย {{value}} ตัว",
      INVALID_EMAIL: "กรุณากรอกอีเมลที่ถูกต้อง",
      PASSWORD_MISMATCH: "รหัสผ่านไม่ตรงกัน",
      PASSWORD_INVALID: "รูปแบบ 'รหัสผ่าน' ไม่ถูกต้อง",
      PLEASE_SELECT: "กรุณาเลือก",
      PLEASE_SELECT_TIME_SLOTS: "กรุณาเลือกช่วงเวลา",
      PLEASE_SELECT_FILE: "กรุณาเลือกไฟล์",
      PLEASE_ADD_ALL_DOCUMENTS: "กรุณาเพิ่มเอกสารให้ครบทุกหัวข้อ",

      DUPLICATE_DOC_NO: "เลขที่เอกสารมีในระบบแล้วกรุณากรอกใหม่",
    },
    SWEETALERT: {
      CONFIRMATION_TITLE: "การยืนยัน",
      CONFIRMATION_TEXT: "คุณแน่ใจหรือว่าต้องการดำเนินการต่อ?",
      CONFIRMATION_DELETE_TEXT: "คุณแน่ใจหรือว่าต้องการลบสิ้งนี้?",
      CONFIRMATION_SAVE_TITLE: "ยืนยันบันทึก",
      CREATE_DATA: "สร้างข้อมูล",
      CREATE_DATA_TEXT: "คุณแน่ใจหรือว่าต้องการสร้างข้อมูลนี้?",
      UPDATE_DATA: "อัปเดตข้อมูล",
      UPDATE_DATA_TEXT: "คุณแน่ใจหรือว่าต้องการอัปเดตข้อมูลนี้?",
      SUCCESS_TITLE: "สำเร็จ",
      SUCCESS_TEXT: "สร้างข้อมูลใหม่เรียบร้อยแล้ว",
      SUCCESS_TEXT_UPDATE: "ข้อมูลได้อัปเดตเรียบร้อยแล้วแล้ว",
      SUCCESS_TEXT_DELETE: "ข้อมูลได้ถูกลบเรียบร้อยแล้ว",
      ERROR_TITLE: "ไม่สำเร็จ",
      ERROR_TEXT: "ดูเหมือนว่ามีบางอย่างผิดพลาด",
      WARNING_TITLE: "คำเตือน",
      WARNING_TEXT: "มีบางอย่างไม่ถูกต้อง อาจทำให้คุณไม่สามารถดำเนินการต่อได้",
      WARNING_IMAGE_SIZE_TITLE: "รูปภาพมีขนาดใหญ่เกินไป",
      WARNING_IMAGE_SIZE_TEXT:
        "กรุณาตรวจสอบขนาดรูปภาพต้องไม่เกิน {{value}} {{unit}}.",

      ERROR_APPROVER_DUPLICATE_OWNER: "ผู้ขอไม่สามารถเป็นผู้รับรองได้",
      ERROR_COMMITTEE_DUPLICATE: "ท่านได้เลือกกรรมการท่านนี้แล้ว",
      ERROR_COMMITTEE_EXTERNAL: "กรรมการภายนอกมีได้ไม่เกิน 1 คน",
      ERROR_COMMITTEE_INTERNAL: "กรรมการภายในมีได้ไม่เกิน 2 คน",

      ERROR_NOTFOUND_DOC: "ไม่พบหมายเลขเอกสาร",
      ERROR_NOTFOUND_DOC_BY_NAME: "ไม่พบชื่อ-สกุลที่ค้นหา",
      ERROR_REQUIRED: "กรุณากรอกข้อมูลให้ครบ",
      //
      APPROVE_CONFIRMATION: "ยืนยันอนุมัติ",
      SUCCESS_APPROVE_TEXT: "อนุมัติข้อมูลคำร้องเรียบร้อยแล้ว",
      REJECT_CONFIRMATION: "ยืนยันไม่อนุมัติ",
      SUCCESS_REJECT_TEXT: "หมายเหตุการแก้ไขได้ถูกส่งไปยังผู้ยื่นคำร้องแล้ว",
      CONFIRMATION_SAVE_DRAFT_TITLE: "บันทึกแบบร่าง",
      CONFIRMATION_SUBMIT_REQUEST_TITLE: "ยืนยันยื่นขอประเมิน",
      ACCEPT_INVITATION_CONFIRMATION: "ตอบรับคำเชิญ",
      SEND_INVITATION_LETTER: "ส่งหนังสือเชิญประชุม",
      SEND_EVALUATION_RESULT: "ส่งผลการประเมิน",
      EDIT_EVALUATION_RESULT: "แก้ไขผลการประเมิน",
      SEND_REQUEST_RESULT: "ส่งบันทึกแจ้งข้อเสนอแนะ",
      SEND_TO_CHAIRMAN_TO_AUDIT: "ส่งให้ประธานคณะกรรมการตรวจสอบ",
      ISSUE_A_CERTIFICATE: "สร้างใบรับรอง",
      APPROVE_A_CERTIFICATE: "อนุมัติใบรับรอง",
      SAVE_DOCUMENT_RESULT: "บันทึกคำแนะนำเอกสาร",
    },
    MISC: {
      HELLO: "สวัสดี",
      ASSOC_PROF: "ผู้ช่วยศาสตราจารย์",
    },
    TABLE: {
      NO_DATA_DISPLAY: "ไม่มีรายการแสดง",
      NO_DATA: "ไม่มีรายการ",
      TOTAL: "รวม",
      SUMMARY_TOTAL: "รวมทั้งหมด",
      TOTAL_RESULT: "ทั้งหมด",
      TOTAL_LIST: "รายการ",
      CUSTOMER_PATIENT: "ลูกค้า / ผู้ป่วย",
      AGE: "อายุ",
      AGE_YEAR: "อายุ (ปี)",
      ID: "เลขที่ประจำตัวบัตรประชาชน",
      PHONE: "เบอร์ติดต่อ",
      EMERGENCY: "ฉุกเฉิน",
      LINE: "LINE",
      LAST_UPDATED: "แก้ไขล่าสุด",
      LAST_LOGIN: "เข้าสู่ระบบล่าสุด",
      OPTION: "ตัวเลือก",
      BY: "by",
      CONNECTED: "เชื่อมต่อแล้ว",
      NOT_CONNECTED: "ไม่ได้เชื่อมต่อ",
      DOC_NO: "เลขที่",
      DATE: "วันที่",
      OPD_LIST: "รายการตรวจ",
      DIAG_LIST: "การรักษา",
      RESPONSIBLE_DOCTOR: "แพทย์ผู้รับผิดชอบ",
      SUB_TOTAL: "ราคารวม",
      NET_PRICE: "ยอดรวม",
      PAID_PRICE: "ยอดที่ต้องชำระ",
      STATUS: "สถานะ",
      PAID: "ชำระแล้ว",
      VOLUME_NO_DOC_NO: "เล่มที่/เลขที่",
      REFERENCE: "อ้างอิงจาก",
      ISSUED_BY: "ออกให้โดย",
      ITEMS: "รายการ",
      PRICE_PER_UNIT: "ราคา/หน่วย",
      AMOUNT: "จำนวน",
      DISCOUNT: "ส่วนลด",
      BAHT: "บาท",
      MEDICINE_USAGE: "การใช้ยา",
      VAT: "ภาษีมูลค่าเพิ่ม ({{value}})",
      SERVICE_DATE: "วันที่รับบริการ",
      COMPLETED_DATE: "วันที่รับบริการเสร็จสิ้น",
      EXAMINATION_ROOM: "ห้องตรวจรักษา",

      // REPORT
      RECEIPT_NO: "เลขที่ใบเสร็จ",
      APPOINTMENT: "นัดหมาย",

      // SETTING
      CODE: "รหัส",
      PRICE: "ราคา",
      UNIT: "หน่วย",
      NUMBER_OF_MEDICINE: "จำนวนรายการยา",
      ACCOUNT_NAME: "ชื่อบัญชี",
      ACCOUNT_NO: "เลขที่บัญชี",
      USED_FOR: "ใช้สำหรับ",
      NAME: "ชื่อ",
      NAME_CODE: "ชื่อ / รหัส",
      LICENSE_NO: "เลขที่ใบอนุญาต",
      EMAIL: "อีเมล",
      ROLE: "บทบาท",
      DESCRIPTION: "คำอธิบาย",
      GROUP: "กลุ่ม",
      CATEGORY: "หมวดหมู่",
      TYPE: "ประเภท",
      MEDICINE_ITEM_COUNT: "จำนวนรายการยา",
      MEDICINE_CATEGORY: "หมวดหมู่ยา",
      MEDICINE_TYPE: "ประเภทยา",
      MEDICINE_NAME: "ชื่อยา",
      DOCTOR: "แพทย์",
      FEE: "ค่าแพทย์",
      UNIT_NAME: "ชื่อหน่วยนับ",
      PRIMARY_UNIT: "หน่วยหลัก",
      MULTIPILIER: "อัตรา/หน่วย",
      MEDICINE_EQUIPMENT_PRICE_PER_TIME: "ค่ายา/อุปกรณ์ (/ครั้ง)",
      TIMES: "จำนวนครั้ง",
      SELL_PRICE: "ราคาขาย",
      USES_AMOUNTPER_TIME: "จำนวนที่ใช้/ครั้ง",
      TYPE_OF_SERVICE: "ลักษณะการให้บริการ",
      SHOW: "แสดง",
      ENTRIES: "รายการ",
      ALLERGIC_DRUG_NAME: "ชื่อยาที่แพ้",
      SYMPTOMS_WHEN_ALLERGIC_TO_DRUGS: "อาการเมื่อแพ้ยา",
      ALLERGIC_DRUG_GROUP: "กลุ่มยาที่แพ้",

      // REPORT
      OWNER_NAME: "ชื่อผู้ยื่น",
      REQUEST_POSITION: "ตำแหน่งทางวิชาการที่ขอ",
      FIELD_OF_STUDY: "สังกัดสาขาวิชา",
      REQUEST_DATE: "วันที่ผู้ยื่นขอประเมิน",
      APPROVE_DATE: "วันที่อนุมัติ",
      REQUEST_STATUS: "สถานะการยื่นขอ",
      PROCESS_TIME_SECTION_1:
        "ระยะเวลาดำเนินการ (วัน) ช่วงที่ 1 <br> (ยื่นเสนอขอ - เลือกกรรมการประเมิน)",
      PROCESS_TIME_SECTION_2:
        "ระยะเวลาดำเนินการ (วัน) ช่วงที่ 2 <br> (เลือกกรรมการประเมิน - ประชุมและพิจารณา)",
      PROCESS_TIME_SECTION_3:
        "ระยะเวลาดำเนินการ (วัน) ช่วงที่ 3 <br> (ประชุมและพิจารณา - อนุมัติ)",
      COMMITTEE_NAME: "ชื่อกรรมการ",
      COMMITTEE_POSITION: "ตำแหน่งกรรมการประเมิน",
      EVAL_POSITION: "ตำแหน่งทางวิชาการที่ประเมิน",
      NUMBER_OF_REQUEST: "จำนวนครั้งที่ประเมินต่อ",
      NUMBER_OF_ASSIS_PROF: "จำนวนผู้ยื่นขอผู้ช่วยศาสตราจารย์",
      NUMBER_OF_SP_ASSIS_PROF: "จำนวนผู้ยื่นขอผู้ช่วยศาสตราจารย์พิเศษ",
      NUMBER_OF_ASSOC_PROF: "จำนวนผู้ยื่นขอรองศาสตราจารย์",
      NUMBER_OF_SP_ASSOC_PROF: "จำนวนผู้ยื่นขอรองศาสตราจารย์พิเศษ",
      NUMBER_OF_ASSIS_PROF_TABLE: "จำนวนผู้ยื่นขอ <br> ผู้ช่วยศาสตราจารย์",
      NUMBER_OF_SP_ASSIS_PROF_TABLE:
        "จำนวนผู้ยื่นขอ <br> ผู้ช่วยศาสตราจารย์พิเศษ",
      NUMBER_OF_ASSOC_PROF_TABLE: "จำนวนผู้ยื่นขอ <br> รองศาสตราจารย์",
      NUMBER_OF_SP_ASSOC_PROF_TABLE: "จำนวนผู้ยื่นขอ <br> รองศาสตราจารย์พิเศษ",
      Q_TIMES: "ครั้ง",
      Q_PEOPLE: "คน",
      COMMITTEE_TYPE: "ประเภทกรรมการ",
      NUMBER_OF_REQUESTER: "จำนวนผู้ยื่นขอทั้งหมด",

      EVALUATION_DATE: "วันที่ประชุม",
      FACULTY: "คณะ",
    },
    DASHBOARD: {
      NAME: "ชื่อรายการ",
      DATE: "วันที่",
      FULL_NAME: "ชื่อ - นามสกุล",
      COMPANY: "บริษัท",
      DEPARTMENT: "แผนก",
      CHECK_IN_TIME: "เข้างานเช้า",
      LUNCH_TIME: "เวลาพักเที่ยง",
      BREAK_TIME: "เวลาพักเที่ยง",
      BACK_TIME: "เข้างานบ่าย",
      CHECK_OUT_TIME: "เลิกงาน",
      LATE: "สาย (นาที)",
      LEAVE: "ลา",
      TIME_INTERVAL: "ช่วงเวลา",
      START_DATE: "วันที่เริ่มต้น",
      END_DATE: "วันที่สิ้นสุด",
      QUATER: "ไตรมาส",
      FULLNAME: "ชื่อ-นามสกุล",
      NICKNAME: "ชื่อเล่น",
      DAY_OFF_TYPE: "ประเภทวันหยุด",
      LEAVE_TYPE: "ประเภทการลา",
      NOTE: "หมายเหตุ",
      ATTENDANCE_TIME: "เวลาเข้างาน",
      LATE_MINUTE: "สาย(นาที)",
      CREATED_TIME: "เวลาที่สร้าง",
      AVERAGE_PER_PERSON_PRICE: "ค่าเฉลี่ย(บาท/คน)",
      DEPARTMENT_DETAILS: {
        DEPARTMENT: "แผนก",
        TOTAL_ATTENDANCE: "จำนวน(มา/ทั้งหมด)",
        TOTAL_DAYOFF: "จำนวน(หยุด/ทั้งหมด)",
        TOTAL_OTHER: "จำนวน(อื่นๆ/ทั้งหมด)",
        PERCENTAGE: "เปอร์เซ็นต์",
      },
      STATUS: "สถานะ",
    },
    ENTRY_INFORMATION: {
      DATE: "วันที่",
      FULL_NAME: "ชื่อ - นามสกุล",
      COMPANY: "บริษัท",
      DEPARTMENT: "แผนก",
      CHECK_IN_TIME: "เข้างานเช้า",
      LUNCH_TIME: "เวลาพักเที่ยง",
      BREAK_TIME: "เวลาพักเที่ยง",
      BACK_TIME: "เข้างานบ่าย",
      CHECK_OUT_TIME: "เลิกงาน",
      LATE: "สาย (นาที)",
      LEAVE: "ลา",
      ADJUSTED: "ปรับปรุงเวลา",
      NICKNAME: "ชื่อเล่น",
      LEAVE_TYPE: "ประเภทการลา",
      STATUS: "สถานะ",
      START_LEAVE_DATE: "วันที่ลาเริ่มต้น",
      END_LEAVE_DATE: "วันที่ลาสิ้นสุด",
      REASON: "เหตุผล",
      TIME_INTERVAL: "ช่วงเวลา",
      JOB_POSITION: "ตำแหน่ง",
    },
    LEAVE_LATE_INFORMATION: {
      FULL_NAME: "ชื่อ-นามสกุล",
      COMPANY: "บริษัท",
      DEPARTMENT: "แผนก",
      LEAVE_TYPES: "ประเภทการลา",
      LEAVE_DATGE: "วันที่ลาเริ่มต้น",
      UNTIL_THE_DATE: "วันที่ลาสิ้นสุด",
      LEAVE_PERIOD: "ช่วงเวลา",
      REASON: "เหตุผล",
      STATUS: "สถานะ"
    },
    SALARY: {
      FULL_NAME: "ชื่อ-นามสกุล",
      COMPANY: "บริษัท",
      DEPARTMENT: "แผนก",
      EMPLOYEE: "พนักงาน",
      SALARY: "เงินเดือน",
      DILIGENCE_ALLOWANCE: "เบี้ยขยัน",
      SUSPENDED: "พักงาน",
      OTHER: "รายการหักอื่นๆ",
      DILIGENCE_ALLOWANCE_COMPANY: "เบี้ยขยัน (กองกลาง)",
      ALLOWANCE: " เบี้ยเลี้ยง",
      RETROACTIVE: "เงินย้อนหลัง + พิเศษ",
      ADVANCE_PRICE: "เบิกเงินล่วงหน้า",
      OTHER_PLUS: "รายรับอื่นๆ",
      INCENTIVE: "อินเซ็นทีฟ",
      ON_TIME: "ตรงต่อเวลา",
      COMMISSION: "คอมมิชชั่น",
      SAVINGS: "เงินสะสม",
      SOCIAL_SECURITY: "ประกันสังคม",
      LATE: "มาสาย",
      TOOL_COSTS: "ค่าเครื่องมือ",
      WORK_ERROR: "งานผิดพลาด",
      LEAVE: "ลางาน",
      POINT_EXCHANGE_DIFFERENCE: "ค่าส่วนต่างแลกแต้ม",
      COMMISSION_RECEIVED: "คอมมิชชั่นที่รับแล้ว",
      GIFT_VALUE: "ค่าของขวัญ",
      TOTAL: "เงินได้สุทธิ",
      ABSENCE: "ขาดงาน",
      JOB_POSITION: "ตำแหน่งงาน",
      RESIGNATION_PAY_DEDUCTION: "ยอดเงินหักกรณีลาออก",
    },
    COMMISSION: {
      MONTH: "เดือน",
      YEAR: "ปี",
      TOTAL_COMMISSION: "ยอดคอมมิชชั่น",
      DATE: "วัน/เดือน/ปี ที่บันทึก",
      LIST_DATE: "วันที่",
      COMMISSION_ROUND: "รอบของค่าคอมมิชชั่น",
      TIME_INTERVAL: "ช่วงเวลา",
      TOTAL_COMMISSION_AMOUNT: "ค่าคอมมิชชั่นทั้งหมด",
      COMMISSION_PAID_STATUS: "สถานะจ่าย",
      CREATED_DATE: "วันที่",
      CONDITION: {
        TITLE: 'เงื่อนไขไม่คิดค่าคอมมิชชั่น',
        ABSENCE: 'ขาดงาน',
        LEAVE: 'ลาปกติ',
        LATE_LEAVE: "ลาเข้าสาย",
        LATE: 'มาสาย(ไม่มีเงื่อนไข)',
        LATE_WITH_CONDITION: 'มาสาย(มีเงื่อนไข)รวมไม่เกิน',
        SPECIAL_LEAVE: 'ลากรณีพิเศษ',
      },
      FILTER: 'กรองข้อมูลตาม',
      DATATABLE: {
        COMMISSION_ROUND: "รอบของค่าคอมมิชชั่น",
        TIME_INTERVAL: "ช่วงเวลา",
        FULL_NAME: "ชื่อ-นามสกุล",
        NICKNAME: "ชื่อเล่น",
        COMPANY_NAME: "บริษัท",
        DEPARTMENT_NAME: "แผนก",
        TOTAL_COMMISSION_AMOUNT: "ค่าคอมมิชชั่นทั้งหมด",
        AVG_PER_PERSON: "ค่าเฉลี่ย(บาท/คน)",
        COMMISSION_PAID_STATUS: "สถานะจ่าย",
        RIGHT_TO_RECEIVE_COMMISSION: "สิทธิ์การได้รับ",
      },
      STATUS: {
        PAID: "จ่ายแล้ว",
        UNPAID: "ยังไม่จ่าย",
        RECEIVED: "ได้รับ",
        NOT_RECEIVED: "ไม่ได้รับ",
      },
      COMMISSION_ROUND_TYPE: {
        DATE_RANGE: "ช่วงวันที่",
        MONTH: "เดือน",
        YEAR: "ปี",
      }
    },
    EMPLOYEE: {
      NAME: "ชื่อ-นามสกุล",
      FIRST_NAME: "ชื่อ",
      LAST_NAME: "นามสกุล",
      ROLE: "ตำแหน่ง",
      WORK_EXPERIENCE: "อายุงาน",
      SALARY: "เงินเดือนปัจจุบัน",
      INCENTIVE: "อินเซ็นทีฟ",
      INCENTIVE_PERCENT: "อินเซ็นทีฟ %",
      COMPANY: "บริษัท",
      DEPARTMENT: "แผนก",
      NICKNAME: "ชื่อเล่น",
      MANAGER: "หัวหน้างาน",
      START_WORKING_DATE: "วันที่เริ่มทำงาน",
      BIRTHDAY: "วัน/เดือน/ปี เกิด",
      AGE: "อายุ",
      EMAIL: "E-mail",
      TEL: "เบอร์โทรศัพท์",
      SALARY_TYPE: "ประเภทเงินเดือน",
      EMERGENCY_CONTACT_NAME: "ชื่อผู้ติดต่อฉุกเฉิน",
      EMERGENCY_CONTACT_NUMBER: "เบอร์ติดต่อฉุกเฉิน",
      RELATION: "ความสัมพันธ์",
      BANK: "ธนาคาร",
      ACCOUNT_NUMBER: "เลขที่บัญชี",
      SOCIAL_SECURITY: "ประกันสังคม",
      NEW_SALARY: "เงินเดือนใหม่",
      SAVINGS: "เงินสะสม",
      COLLECT_POINT: "แต้มสะสม",
      STATUS: "สถานะ",
      INTERN: "ทดลองงาน",
      START_DATE_OF_COLLECT_MONEY: "วันที่เริ่มต้นรับเงินสะสม",
      SAVINGS_PERCENTAGE: "เงินสะสม%",
      SUM_SAVINGS: "ยอดเงินสะสม",
      COEFFICIENT_VALUE: "ค่าสัมประสิทธิ์",
      NATIONAL_ID_CARD: "เลขบัตรประชาชน",
      ADDRESS: "ที่อยู่ตามบัตรประชาชน",
      PROBATION_COMPLETION_DATE: "วันที่ผ่านโปร",
      PAYING_COMPANY: "บริษัทผู้จ่ายเงินเดือน",
      RESIGNATION_DATE: "วันที่สิ้นสุดการทำงาน",
      RESIGNATION_PAY_TYPE: "การจ่ายเงินเดือน (ลาออก)",
      INTERN_PROBATION: "ทดลองงาน"
    },
    USER: {
      FULL_NAME: "ชื่อ-นามสกุล",
      USER_NAME: "ชื่อผู้ใช้งาน",
      ROLE: "บทบาทการใช้งาน",
    },
    PERMISSION: {
      NAME: "ชื่อ",
    },
    HOLIDAY: {
      NUMBER_HOLIDAY_WEEK: "จำนวนวันหยุดต่อสัปดาห์",
      DAY_OFF: "วันหยุด",
      DAY_OFF_NAME: "ชื่อวันหยุด",
      DATE: "วัน/เดือน/ปี",
    },
    LEAVE: {
      LEAVE_NAME: "ชื่อการลา",
      ADVANCE_NOTICE: "แจ้งล่วงหน้า",
      INFORM_ADVANCE: "จำนวนวันที่ต้องแจ้งล่วงหน้า",
      QUOTA: "โควต้า (ครั้ง)",
      LEAVE_QUOTA: "โควต้าการลา (วัน)",
      QUOTA_ROUND: "รอบโควต้า",
      STATUS: "สถานะ",
      START_QUOTA: "วันที่ต้องการเริ่มโควต้า",
      MONTHS: "เดือน",
      ELIGIBLE_USER_GROUP: "กลุ่มผู้มีสิทธิ์ใช้งาน",
      MIN_ELIGIBLE_WORK_AGE: "อายุงานขั้นต่ำ (ที่จะใช้สิทธิ์ได้)",
      MIN_ELIGIBLE_WORK_AGE_TYPES: "ช่วงเวลา",
      UNIT: "หน่วย",
      MAX_ACCUMULATE_LEAVE_DATE: "สะสมวันลาได้สูงสุด (วัน)",
      COLLECTION_PERIOD: "ระยะเวลาการเก็บสะสม",
      CONTINUOUS_LEAVE_DATE: "ห้ามลาต่อเนื่องเกิน (วัน)",
      SPECIAL_LEAVE_DATE: "กำหนดวันห้ามลาเฉพาะ",
      FINE_FORMAT: "รูปแบบค่าปรับ",
      ACTIVE: "เปิดใช้งาน",
      BADGE: "ไฮไลท์",
      SHARE_QUOTUM: "ชื่อการลาที่ต้องการแชร์",
      IS_DAILY_LEAVE_LIMIT_PER_DAY: "กำหนดจำนวนพนักงานลาต่อวัน",
      DAILY_LEAVE_LIMIT_PER_DAY: "จำนวนพนักงานลาต่อวัน"
    },
    FINE: {
      FINE_NAME: "ชื่อค่าปรับ",
      FINE: "ค่าปรับ",
      UNIT: "หน่วย",
      STATUS: "สถานะ",
      LEAVE_TYPE_NAME: "ประเภทค่าปรับ",
      MULTIPLIER: "ตัวคูณ",
      ACTIVE: "เปิดใช้งาน",
    },
    COMPANY_INFORMATION: {
      NAME_TH: "ชื่อภาษาไทย",
      NAME_EN: "ชื่อภาษาอังกฤษ",
      COMPANY_NAME_TH: "ชื่อกิจการภาษาไทย",
      COMPANY_NAME_EN: "ชื่อกิจการภาษาอังกฤษ",
      TEL: "เบอร์โทรศัพท์",
      ADDRESS: "ที่อยู่",
      PROVINCE: "จังหวัด",
      AMPHUR: "อำเภอ",
      TAMBON: "ตำบล",
      POST_CODE: "รหัสไปรษณี",
      LATITUDE: "Latitude (กิจการ)",
      LONGITUDE: "Longitude (กิจการ)",
      START_CHECK_IN: "เวลาที่เริ่มเข้างานได้",
      ENTRY_TIME_MORNING: "เวลาเข้างานเช้า",
      LUNCH_BREAK: "พักเที่ยง",
      TIME_OFF_WORK: "เวลาเลิกงาน",
      TIME_OF_STAY: "เวลาที่พักได้ (ชั่วโมง)",
      FINE_FORMAT: "รูปแบบค่าปรับ",
      OVERTIME_PRICE: "เบี้ยขยัน",
      BANK: "ธนาคาร",
      BANK_NUMBER: "เลขที่บัญชี",
    },
    DEPARTMENT_INFORMATION: {
      DEPARTMENT_NAME: "ชื่อแผนก",
      COMPANY_NAME: "ชื่อบริษัท",
      APPROVER_1: "ผู้อนุมัติลำดับที่ 1",
      APPROVER_2: "ผู้อนุมัติลำดับที่ 2",
      APPROVER_3: "ผู้อนุมัติลำดับที่ 3",
      APPROVER_4: "ผู้อนุมัติลำดับที่ 4 (สำรอง)",
    },
    JOB_POSITION: {
      JOB_TITLE: "ชื่อตำแหน่งงาน",
      DEPARTMENT_NAME: "ชื่อแผนก",
      COMPANY_NAME: "ชื่อบริษัท",
      INCENTIVE: "อินเซ็นทีฟ %",
      COLLECT_MONEY: "เงินสะสม %",
      COEFFICIENT: "สัมประสิทธิ์",
    },
    USER_ROLE_SUPERVISOR: {
      NAME: "ชื่อ-นามสกุล",
      TEL: "เบอร์โทรศัพท์",
      ROLE: "สิทธิ์การใช้งาน",
      PERMISSION: "สิทธิ์การใช้งาน",
    },
    COMPONENT_INFO_DEPARTMENT: {
      COMPANY: "ชื่อบริษัท",
      DEPARTMENT: "แผนก",
      NAME: "ชื่อ-นามสกุล",
    },
    POSITION: {
      NAME: "ชื่อ-นามสกุล",
      POSITION: "ตำแหน่ง",
      WORK_EXPERIENCE: "อายุงาน",
      SALARY: "เงินเดือน",
      COMPANY: "ชื่อบริษัท",
      DEPARTMENT: "แผนก",
    },
    POLICY_MANAGEMENT: {
      RULES: "กฎระเบียบ",
      DESCRIPTION: "รายละเอียด",
    },
    WORKING_YEAR: {
      WORKING_YEAR: "ปีปฎิทิน",
      INPUT_YEAR: "ระบุปี (พ.ศ.)",
      INPUT_YEAR_ERROR: "กรุณากรอกปี",
      DELETE_TITLE: "ลบปีปฎิทิน",
      DELETE_DES: "ยืนยันการลบปีปฎิทิน",
      DELETE_SUCCESS: "ลบปีปฎิทินเสร็จสิ้น",
      SET_CURRENT_YEAR: "กำหนดเป็นปีปัจจุบัน",
    },
    SPECIAL_LEAVE: {
      DATE: "วันที่",
      FULL_NAME: "ชื่อ-นามสกุล",
      NAME: "ชื่อเล่น",
      COMPANY: "บริษัท",
      DEPARTMENT: "แผนก",
      JOB_POSITION: "ตำแหน่ง",
      SPECIAL_LEAVE_TYPE_NAME: "ลากรณีพิเศษ",
      START_DATE: "วันที่เริ่มต้น",
      END_DATE: "วันที่สิ้นสุด",
      SALARY: "เงินเดือน",
      INCENTIVE: "อินเซ็นทีฟ",
      COLLECT_MONEY: "เงินสะสม",
      NOTE: "หมายเหตุ",
      SPECIAL_LEAVE_TYPES: "ประเภทการลา",
      SPECIAL_LEAVE_DAY_AMOUNT: "จำนวนวันที่ลา",
      STAFF_PLACEHOLDER: "กรุณาเลือกพนักงาน",
      SPECIAL_LEAVE_TYPE_PLACEHOLDER: "กรุณาเลือกประเภทการลา",
      START_DATE_PLACEHOLDER: "กรุณาเลือกวันที่เริ่มต้น",
      END_DATE_PLACEHOLDER: "กรุณาเลือกวันที่สิ้นสุด",
      NOTES_PLACEHOLDER: "กรุณากรอกหมายเหตุ",
      IMAGES: "รูปภาพ",
      VALIDATE: {
        STAFF_REQUIRED: "กรุณาเลือกพนักงาน",
        SPECIAL_LEAVE_TYPE_REQUIRED: "กรุณาเลือกประเภทการลา",
        START_DATE_REQUIRED: "กรุณาเลือกวันที่เริ่มต้น",
        END_DATE_REQUIRED: "กรุณาเลือกวันที่สิ้นสุด",
        NOTES_REQUIRED: "กรุณากรอกหมายเหตุ",
        IMAGE_REQUIRED: "กรุณาอัปโหลดรูปภาพ",
        SALARY_REQUIRED: "กรุณากรอกเงินเดือน",
        INCENTIVE_REQUIRED: "กรุณากรอกอินเซ็นทีฟ",
        COLLECT_MONEY_REQUIRED: "กรุณากรอกเงินสะสม",
      }
    },
    ALLOWANCE: {
      CREATED_DATE: "วันที่",
      NAME: "รายการเบี้ยเลี้ยง",
      FILTER: 'กรองข้อมูลตาม',
      FULLNAME: "ชื่อ-นามสกุล",
      NICKNAME: "ชื่อเล่น",
      COMPANY: "บริษัท",
      DEPARTMENT: "แผนก",
      AMOUNT_RECEIVED: "จำนวนเงินที่ได้รับ",
      STATUS: "สถานะจ่าย",
      REMARK: "หมายเหตุ",
      RECEIVED_ALLOWANCE_DATE: "วันที่ได้รับเบี้ยเลี้ยง",
    },
    OTHER: {
      SELECT_MONTH_AND_YEAR: "เลือกเดือนและปี",
      TIME_INTERVAL: "ระบุช่วงเวลา",
      FINANCIAL_TRANSACTION_TYPE: "ประเภทรายการเงิน",
      DATE: "วันที่",
      NAME: "ชื่อรายการ",
      TOTAL_AMOUNT: "ยอดทั้งหมด",
      START_DATE: "วันที่เริ่มต้น",
      END_DATE: "วันที่สิ้นสุด",
      REMARK: "หมายเหตุ",
      CREATE_NEW_OTHER: "สร้างรายการใหม่",
      OTHER_FILTER: "กรองข้อมูลตาม",
      TABLE: {
        NAME: "ชื่อรายการ",
        FULL_NAME: "ชื่อ-นามสกุล",
        NICKNAME: "ชื่อเล่น",
        COMPANY: "บริษัท",
        DEPARTMENT: "แผนก",
        FINANCIAL_TRANSACTION_TYPE: "ประเภทรายการเงิน",
        TOTAL_AMOUNT: "ยอดทั้งหมด",
        AVERAGE_PER_PERSON: "ค่าเฉลี่ย(บาท/คน)",
        START_DATE: "วันที่เริ่มต้น",
        END_DATE: "วันที่สิ้นสุด",
      }
    },
    COLLECT_POINT: {
      LIST_TYPE: "ประเภทรายการ",
      COLLECT_POINT_FILTER_TYPE: "ประเภทการทำรายการ",
      SELECT_MONTH_AND_YEAR: "เลือกเดือนและปี",
      SELECT_TIME_INTERVAL: "ระบุช่วงเวลา",
      FULL_NAME: "ชื่อ-นามสกุล",
      DEPARTMENT: "แผนก",
      FIRST_TYPE: {
        FORM: {
          COLLECT_POINT_FILTER_TYPE: "ประเภทการทำรายการ",
          CREATED_DATE: "วันที่",
          NAME: "รายการแต้มสะสม",
          TOTAL_POINT_AMOUNT: "จำนวนแต้มทั้งหมด",
          AMOUNT_OF_POINT_PER_PERSON: "จำนวนแต้ม(ต่อคน)",
          START_DATE: "วันที่เริ่มต้น",
          END_DATE: "วันที่สิ้นสุด",
          DEPARTMENT_THAT_RELATE: "แผนกที่เกี่ยวข้อง",
          REMARK: "หมายเหตุ",
          ATTENDNACE_STATUS: "สถานะการมาทำงาน",
          LEAVE_TYPE: "ประเภทการขาดงาน(มีสิทธิ์ได้รับแต้ม)",
          COMPANY: "บริษัท",
          DEPARTMENT: "แผนก",
          FULL_NAME: "ชื่อ-นามสกุล",
          IS_ABSENCE: "ขาด",
          IS_LEAVE: "ลา",
          IS_LATE: "มาสาย",
          IS_SPECIAL_LEAVE: "ลากรณีพิเศษ",
        },
        TABLE: {
          CREATED_DATE: "วันที่",
          NAME: "รายการแต้มสะสม",
          DEPARTMENT_THAT_RELATED: "แผนกที่เกี่ยวข้อง",
          TOTAL_AMOUNT_OF_POINT: "จำนวนแต้มทั้งหมด",
          TOTAL_AMOUNT_PER_PERSON: "จำนวนแต้ม(ต่อคน)",
          START_DATE: "วันที่เริ่มต้น",
          END_DATE: "วันที่สิ้นสุด",
          COME_EVERYDAY_DAY: "มาครบทุกวัน",
          NOT_COME_EVERYDAY_DAY: "มาทำงานไม่ครบ",
          IS_ABSENCE: "ขาด",
          IS_LEAVE: "ลา",
          IS_LATE: "มาสาย",
          IS_SPECIAL_LEAVE: "ลากรณีพิเศษ",
          REMARK: "หมายเหตุ",
        },
        FORM_TABLE: {
          NAME: "รายการแต้มสะสม",
          FULL_NAME: "ชื่อ-นามสกุล",
          NICKNAME: "ชื่อเล่น",
          COMPANY: "บริษัท",
          DEPARTMENT: "แผนก",
          JOB_POSITION: "ตำแหน่ง",
          START_DATE: "วันที่เริ่มต้น",
          END_DATE: "วันที่สิ้นสุด",
          AMOUNT_OF_POINT_PER_PERSON: "จำนวนแต้ม(ต่อคน)",
          RIGHT_TO_RECEIVE_POINT: "สิทธิ์การได้รับ",
          REMARK: "หมายเหตุ",
        },
      },
      SECOND_TYPE: {
        TABLE: {
          CREATED_DATE: "วันที่",
          FULL_NAME: "ชื่อ-นามสกุล",
          NICKNAME: "ชื่อเล่น",
          DEPARTMENT: "แผนก",
          JOB_POSITION: "ตำแหน่ง",
          CURRENT_COLLECTED_POINT: "คะแนนรวมปัจจุบัน",
          TOTAL_POINT_BEFORE_ADJUSTMENT: "คะแนนรวมก่อนปรับ",
          COLLECT_POINT_FILTER_TYPE: "ประเภทการทำรายการ",
          COLLECT_POINT_ACTION: "การปรับแต้มสะสม",
          POINT_THAT_ADJUSTED: "จำนวนแต้มที่ปรับ",
          TOTAL_POINT_AFTER_ADJUSTMENT: "คะแนนรวมหลังปรับ",
          TOTAL_POINT_EXCHANGE: "จำนวนแต้มแลก",
          TOTAL_POINT_VALUE: "มูลค่าแต้ม(บาท)",
          TOTAL_MONEY_VALUE: "มูลค่าเงินรวม",
          TOTAL_POINT_LEFT: "คะแนนคงเหลือ",
          REMARK: "หมายเหตุ",
          CREATOR: "ผู้บันทึกช้อมูล",
        },
        FORM: {
          CREATED_DATE: "วันที่",
          FULL_NAME: "ชื่อ-นามสกุล",
          NICKNAME: "ชื่อเล่น",
          DEPARTMENT: "แผนก",
          JOB_POSITION: "ตำแหน่ง",
          FILTER_TYPE: "ประเภทการทำรายการ",
          TOTAL_POINT_BEFORE_ADJUSTMENT: "คะแนนรวมก่อนปรับ",
          COLLECT_POINT_ACTION: "การปรับแต้มสะสม",
          POINT_THAT_ADJUSTED: "จำนวนแต้มที่ปรับ",
          TOTAL_POINT_AFTER_ADJUSTMENT: "คะแนนรวมหลังปรับ",
          TOTAL_POINT_EXCHANGE: "จำนวนแต้มแลก",
          CURRENT_COLLECTED_POINT: "คะแนนรวมปัจจุบัน",
          TOTAL_POINT_VALUE: "มูลค่าแต้ม(บาท)",
          TOTAL_MONEY_VALUE: "มูลค่าเงินรวม",
          TOTAL_POINT_LEFT: "คะแนนคงเหลือ",
          REMARK: "หมายเหตุ",
        }
      },
    },
    AUDIT_LOG: {
      START_DATE: "วันที่เริ่มต้น",
      END_DATE: "วันที่สิ้นสุด",
      TRANSACTION_NUMBER: "เลขที่รายการ",
      CREATOR_NAME: "ชื่อผู้ทำใช้งาน",
      ACTION_NAME: "Action",
      MODULE_NAME: "Module",
      REMARK: "คำอธิบาย",
      DATE: "วันที่และเวลา",
    }
  },
};
